import ApiClient from './ApiClient'
import OpenApiClient from './OpenApiClient'

const client = new ApiClient()
const openClient = new OpenApiClient()

export default {
  /**
   * コメント数を取得
   */
  getCommentsCount (condition = null) {
    return client.get('comments/count', condition)
  },
  /**
   * コメント一覧を取得
   */
  getComments (condition = null) {
    return client.get('comments', condition)
  },
  /**
   * コメントを投稿
   */
  postComment (body = null) {
    return openClient.post('op/comments', body)
  },
  /**
   * 投稿内容プレビュー用画面
   */
  postCommentConfirm (body = null) {
    return openClient.post('op/comments/confirm', body)
  }
}
